import {connect} from 'react-redux'
import withRouter from "../../../components/RouterComponentWrapper";
import AnyGamesDetail from "../../../components/views/liga/AnyGamesDetail";

const mapStateToProps = function (state, ownProps) {
    const urlParams = new URLSearchParams(ownProps.router.location.search);
    const turnierid = urlParams.get('turnierid');
    return {tournamentId: turnierid, userId: state.user.id};
};


const mapDispatchToProps = dispatch => ({
});


export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(AnyGamesDetail))
